import { AppConfig } from "@config/config";
import { TixApiClient } from "./TixApiClient";

export const tixApiClient = new TixApiClient({ baseUrl: AppConfig.TixApiUrl });
